import validate from "/codebuild/output/src15932225/src/findex/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.9.1_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_5f53a7bd0d57cdc1fae0a99d63adaf07/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src15932225/src/findex/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.9.1_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_5f53a7bd0d57cdc1fae0a99d63adaf07/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}